/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';

export default function CheckoutFooter(): ReactElement {
    return (
        <footer className="mt-auto border-t border-border">
            <div className="section-container py-4">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-muted-foreground">
                    {/* RGBARRY-CUSTOMIZATION: checkout footer shows a static copyright line plus the
                        hosted Terms of Use / Privacy Policy links. These target absolute external hosts,
                        so they must be plain <a> (the site-context Link would prefix the path). */}
                    <div>© 2026 Baggallini. All rights reserved.</div>
                    <div className="flex items-center gap-4">
                        <a
                            href="https://dev.baggallini.com/terms-of-use.html"
                            rel="noopener noreferrer"
                            className="hover:text-foreground transition-colors">
                            Terms of use
                        </a>
                        <a
                            href="https://privacy.baggallini.com/privacy-policy"
                            rel="noopener noreferrer"
                            className="hover:text-foreground transition-colors">
                            privacy policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
